import Users from './views/Users.js';
import Products from './views/Products.js';
import PrinterAdmins from './views/PrinterAdmins.js';
import Licenses from './views/Licenses.js';
// import Invoices from "./views/Invoices.js";
// import Transactions from "./views/Transactions.js";
import Profile from './views/Profile.js';
import ProductsCreate from './views/ProductsCreate.js';
import ProductsEdit from './views/ProductsEdit.js';
// import Status from "./views/Status";
import Groups from './views/Groups.js';
import GroupsCreate from './views/GroupsCreate.js';
import GroupsEdit from './views/GroupsEdit.js';
import Margins from './views/Margins';
import MarginsCreate from './views/MarginsCreate.js';
import MarginsEdit from './views/MarginsEdit.js';
import DynamicPrice from './views/DynamicPrice';
import DynamicPriceCreate from './views/DynamicPriceCreate.js';
import DynamicPriceEdit from './views/DynamicPriceEdit.js';
// import ShippingSetting from "./views/ShippingSetting.js";
import CompanySetting from './views/CompanySetting.js';
import TemplateSetting from './views/TemplateSetting.js';
import CSV from './views/CSV.js';
import Plugin from './views/Plugin.js';
// import Register from "./views/Register.js";
import Login from './views/Login.js';
import LiveChat from './views/LiveChat.js';

// import Maps from "views/examples/Maps.js";
// import Tables from "views/examples/Tables.js";
// import Icons from "views/examples/Icons.js";

var routes = [
    // {
    //   path: "/index",
    //   name: "Dashboard",
    //   icon: "ni ni-tv-2 text-primary",
    //   component: Index,
    //   layout: "/admin",
    //   show: true,
    // },
    {
        path: '/index',
        name: 'Whitelabel reseller',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3 6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H8.25C9.04565 3 9.80871 3.31607 10.3713 3.87868C10.9339 4.44129 11.25 5.20435 11.25 6V8.25C11.25 9.04565 10.9339 9.80871 10.3713 10.3713C9.80871 10.9339 9.04565 11.25 8.25 11.25H6C5.20435 11.25 4.44129 10.9339 3.87868 10.3713C3.31607 9.80871 3 9.04565 3 8.25V6ZM12.75 6C12.75 5.20435 13.0661 4.44129 13.6287 3.87868C14.1913 3.31607 14.9544 3 15.75 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V8.25C21 9.04565 20.6839 9.80871 20.1213 10.3713C19.5587 10.9339 18.7956 11.25 18 11.25H15.75C14.9544 11.25 14.1913 10.9339 13.6287 10.3713C13.0661 9.80871 12.75 9.04565 12.75 8.25V6ZM3 15.75C3 14.9544 3.31607 14.1913 3.87868 13.6287C4.44129 13.0661 5.20435 12.75 6 12.75H8.25C9.04565 12.75 9.80871 13.0661 10.3713 13.6287C10.9339 14.1913 11.25 14.9544 11.25 15.75V18C11.25 18.7956 10.9339 19.5587 10.3713 20.1213C9.80871 20.6839 9.04565 21 8.25 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V15.75ZM12.75 15.75C12.75 14.9544 13.0661 14.1913 13.6287 13.6287C14.1913 13.0661 14.9544 12.75 15.75 12.75H18C18.7956 12.75 19.5587 13.0661 20.1213 13.6287C20.6839 14.1913 21 14.9544 21 15.75V18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21H15.75C14.9544 21 14.1913 20.6839 13.6287 20.1213C13.0661 19.5587 12.75 18.7956 12.75 18V15.75Z" fill="#BDBDBD"/>
      </svg>`,
        component: Licenses,
        layout: '/whitelabelsuperadmin',
        show: true,
    },
    {
        path: '/printers',
        name: 'Printer Admins',
        icon: 'fa fa-users',
        component: PrinterAdmins,
        layout: '/whitelabelsuperadmin',
        show: true,
    },
    {
        path: '/index',
        name: 'Products',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3 6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H8.25C9.04565 3 9.80871 3.31607 10.3713 3.87868C10.9339 4.44129 11.25 5.20435 11.25 6V8.25C11.25 9.04565 10.9339 9.80871 10.3713 10.3713C9.80871 10.9339 9.04565 11.25 8.25 11.25H6C5.20435 11.25 4.44129 10.9339 3.87868 10.3713C3.31607 9.80871 3 9.04565 3 8.25V6ZM12.75 6C12.75 5.20435 13.0661 4.44129 13.6287 3.87868C14.1913 3.31607 14.9544 3 15.75 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V8.25C21 9.04565 20.6839 9.80871 20.1213 10.3713C19.5587 10.9339 18.7956 11.25 18 11.25H15.75C14.9544 11.25 14.1913 10.9339 13.6287 10.3713C13.0661 9.80871 12.75 9.04565 12.75 8.25V6ZM3 15.75C3 14.9544 3.31607 14.1913 3.87868 13.6287C4.44129 13.0661 5.20435 12.75 6 12.75H8.25C9.04565 12.75 9.80871 13.0661 10.3713 13.6287C10.9339 14.1913 11.25 14.9544 11.25 15.75V18C11.25 18.7956 10.9339 19.5587 10.3713 20.1213C9.80871 20.6839 9.04565 21 8.25 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V15.75ZM12.75 15.75C12.75 14.9544 13.0661 14.1913 13.6287 13.6287C14.1913 13.0661 14.9544 12.75 15.75 12.75H18C18.7956 12.75 19.5587 13.0661 20.1213 13.6287C20.6839 14.1913 21 14.9544 21 15.75V18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21H15.75C14.9544 21 14.1913 20.6839 13.6287 20.1213C13.0661 19.5587 12.75 18.7956 12.75 18V15.75Z" fill="#BDBDBD"/>
    </svg>`,
        component: Products,
        layout: '/superadmin',
        show: true,
    },
    {
        path: '/products-create',
        name: 'Create Product',
        icon: 'ni ni-key-25 text-info',
        component: ProductsCreate,
        layout: '/superadmin',
        show: false,
    },
    {
        path: '/products-edit/:id',
        name: 'Edit Product',
        icon: 'ni ni-key-25 text-info',
        component: ProductsEdit,
        layout: '/superadmin',
        show: false,
    },
    {
        path: '/users',
        name: 'Users',
        icon: 'ni ni-single-02 text-default',
        component: Users,
        layout: '/superadmin',
        show: true,
    },
    {
        path: '/groups-management',
        name: 'Groups Management',
        icon: 'fa fa-users',
        component: Groups,
        layout: '/superadmin',
        show: true,
    },
    {
        path: '/groups-create',
        name: 'Create Group',
        icon: 'ni ni-key-25 text-info',
        component: GroupsCreate,
        layout: '/superadmin',
        show: false,
    },
    {
        path: '/groups-edit/:id',
        name: 'Edit Group',
        icon: 'ni ni-key-25 text-info',
        component: GroupsEdit,
        layout: '/superadmin',
        show: false,
    },
    {
        path: '/margin',
        name: 'Margin Setting',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M6 12C5.80109 12 5.61032 11.921 5.46967 11.7803C5.32902 11.6397 5.25 11.4489 5.25 11.25V3.75C5.25 3.55109 5.32902 3.36032 5.46967 3.21967C5.61032 3.07902 5.80109 3 6 3C6.19891 3 6.38968 3.07902 6.53033 3.21967C6.67098 3.36032 6.75 3.55109 6.75 3.75V11.25C6.75 11.4489 6.67098 11.6397 6.53033 11.7803C6.38968 11.921 6.19891 12 6 12ZM18 12C17.8011 12 17.6103 11.921 17.4697 11.7803C17.329 11.6397 17.25 11.4489 17.25 11.25V3.75C17.25 3.55109 17.329 3.36032 17.4697 3.21967C17.6103 3.07902 17.8011 3 18 3C18.1989 3 18.3897 3.07902 18.5303 3.21967C18.671 3.36032 18.75 3.55109 18.75 3.75V11.25C18.75 11.4489 18.671 11.6397 18.5303 11.7803C18.3897 11.921 18.1989 12 18 12ZM6.75 20.25V18.75C6.75 18.5511 6.67098 18.3603 6.53033 18.2197C6.38968 18.079 6.19891 18 6 18C5.80109 18 5.61032 18.079 5.46967 18.2197C5.32902 18.3603 5.25 18.5511 5.25 18.75V20.25C5.25 20.4489 5.32902 20.6397 5.46967 20.7803C5.61032 20.921 5.80109 21 6 21C6.19891 21 6.38968 20.921 6.53033 20.7803C6.67098 20.6397 6.75 20.4489 6.75 20.25ZM18.75 18.75V20.25C18.75 20.4489 18.671 20.6397 18.5303 20.7803C18.3897 20.921 18.1989 21 18 21C17.8011 21 17.6103 20.921 17.4697 20.7803C17.329 20.6397 17.25 20.4489 17.25 20.25V18.75C17.25 18.5511 17.329 18.3603 17.4697 18.2197C17.6103 18.079 17.8011 18 18 18C18.1989 18 18.3897 18.079 18.5303 18.2197C18.671 18.3603 18.75 18.5511 18.75 18.75ZM12.75 5.25V3.75C12.75 3.55109 12.671 3.36032 12.5303 3.21967C12.3897 3.07902 12.1989 3 12 3C11.8011 3 11.6103 3.07902 11.4697 3.21967C11.329 3.36032 11.25 3.55109 11.25 3.75V5.25C11.25 5.44891 11.329 5.63968 11.4697 5.78033C11.6103 5.92098 11.8011 6 12 6C12.1989 6 12.3897 5.92098 12.5303 5.78033C12.671 5.63968 12.75 5.44891 12.75 5.25ZM12 21C11.8011 21 11.6103 20.921 11.4697 20.7803C11.329 20.6397 11.25 20.4489 11.25 20.25V12.75C11.25 12.5511 11.329 12.3603 11.4697 12.2197C11.6103 12.079 11.8011 12 12 12C12.1989 12 12.3897 12.079 12.5303 12.2197C12.671 12.3603 12.75 12.5511 12.75 12.75V20.25C12.75 20.4489 12.671 20.6397 12.5303 20.7803C12.3897 20.921 12.1989 21 12 21ZM3.75 15C3.75 15.5967 3.98705 16.169 4.40901 16.591C4.83097 17.0129 5.40326 17.25 6 17.25C6.59674 17.25 7.16903 17.0129 7.59099 16.591C8.01295 16.169 8.25 15.5967 8.25 15C8.25 14.4033 8.01295 13.831 7.59099 13.409C7.16903 12.9871 6.59674 12.75 6 12.75C5.40326 12.75 4.83097 12.9871 4.40901 13.409C3.98705 13.831 3.75 14.4033 3.75 15ZM12 11.25C11.4033 11.25 10.831 11.0129 10.409 10.591C9.98705 10.169 9.75 9.59674 9.75 9C9.75 8.40326 9.98705 7.83097 10.409 7.40901C10.831 6.98705 11.4033 6.75 12 6.75C12.5967 6.75 13.169 6.98705 13.591 7.40901C14.0129 7.83097 14.25 8.40326 14.25 9C14.25 9.59674 14.0129 10.169 13.591 10.591C13.169 11.0129 12.5967 11.25 12 11.25ZM15.75 15C15.75 15.5967 15.9871 16.169 16.409 16.591C16.831 17.0129 17.4033 17.25 18 17.25C18.5967 17.25 19.169 17.0129 19.591 16.591C20.0129 16.169 20.25 15.5967 20.25 15C20.25 14.4033 20.0129 13.831 19.591 13.409C19.169 12.9871 18.5967 12.75 18 12.75C17.4033 12.75 16.831 12.9871 16.409 13.409C15.9871 13.831 15.75 14.4033 15.75 15Z" fill="#BDBDBD"/>
    </svg>`,
        component: Margins,
        layout: '/superadmin',
        show: true,
    },
    {
        path: '/margins-create',
        name: 'Create Margin',
        icon: 'ni ni-key-25 text-info',
        component: MarginsCreate,
        layout: '/superadmin',
        show: false,
    },
    {
        path: '/margins-edit/:id',
        name: 'Edit Margin',
        icon: 'ni ni-key-25 text-info',
        component: MarginsEdit,
        layout: '/superadmin',
        show: false,
    },
    {
        path: '/dynamic-price',
        name: 'Dynamic Price',
        icon: `<svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.67188 14.3298C8.67188 15.6198 9.66188 16.6598 10.8919 16.6598H13.4019C14.4719 16.6598 15.3419 15.7498 15.3419 14.6298C15.3419 13.4098 14.8119 12.9798 14.0219 12.6998L9.99187 11.2998C9.20187 11.0198 8.67188 10.5898 8.67188 9.36984C8.67188 8.24984 9.54187 7.33984 10.6119 7.33984H13.1219C14.3519 7.33984 15.3419 8.37984 15.3419 9.66984" stroke="#bdbdbd" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 6V18" stroke="#bdbdbd" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#bdbdbd" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        component: DynamicPrice,
        layout: '/superadmin',
        show: true,
    },
    {
        path: '/dynamic-price-create',
        name: 'Create Dynamic Price',
        icon: 'ni ni-key-25 text-info',
        component: DynamicPriceCreate,
        layout: '/superadmin',
        show: false,
    },
    {
        path: '/dynamic-price-edit/:id',
        name: 'Edit Dynamic Price',
        icon: 'ni ni-key-25 text-info',
        component: DynamicPriceEdit,
        layout: '/superadmin',
        show: false,
    },
    {
        path: '/csv',
        name: 'Download CSV',
        icon: 'fa fa-file-excel',
        component: CSV,
        layout: '/superadmin',
        show: true,
    },
    {
        path: '/setting',
        name: 'Setting',
        icon: 'ni ni-settings text-info',
        component: CompanySetting,
        layout: '/superadmin',
        show: true,
    },
    {
        path: '/user-profile',
        name: 'Password',
        icon: 'ni ni-single-02 text-primary',
        component: Profile,
        layout: '/superadmin',
        show: false,
    },
    {
        path: '/login',
        name: 'Login',
        icon: 'ni ni-key-25 text-info',
        component: Login,
        layout: '/auth',
        show: false,
    },
    {
        path: '/auth/login',
        name: 'Logout',
        icon: 'ni ni-user-run text-danger',
        layout: '/superadmin',
        show: true,
    },
    // {
    //   path: "/invoices",
    //   name: "Invoices",
    //   icon: "ni ni-single-copy-04 text-primary",
    //   component: Invoices,
    //   layout: "/admin",
    //   show: true,
    // },
    // {
    //   path: "/transactions",
    //   name: "Transactions",
    //   icon: "ni ni-chart-bar-32 text-info",
    //   component: Transactions,
    //   layout: "/admin",
    //   show: true,
    // },
    // {
    //   path: "/status",
    //   name: "Status",
    //   icon: "ni ni-notification-70 text-orange",
    //   component: Status,
    //   layout: "/admin",
    //   show: true,
    // },
    // {
    //   path: "/shipping-setting",
    //   name: "Shipping Setting",
    //   icon: "ni ni-delivery-fast text-pink",
    //   component: ShippingSetting,
    //   layout: "/admin",
    //   show: true,
    // },
    // {
    //   path: "/icons",
    //   name: "Icons",
    //   icon: "ni ni-planet text-blue",
    //   component: Icons,
    //   layout: "/admin",
    // },
    // {
    //   path: "/maps",
    //   name: "Maps",
    //   icon: "ni ni-pin-3 text-orange",
    //   component: Maps,
    //   layout: "/admin",
    // },
    // {
    //   path: "/tables",
    //   name: "Tables",
    //   icon: "ni ni-bullet-list-67 text-red",
    //   component: Tables,
    //   layout: "/admin",
    // },
    // {
    //   path: "/register",
    //   name: "Register",
    //   icon: "ni ni-circle-08 text-pink",
    //   component: Register,
    //   layout: "/auth",
    // },
    {
        path: '/index',
        name: 'Products',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3 6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H8.25C9.04565 3 9.80871 3.31607 10.3713 3.87868C10.9339 4.44129 11.25 5.20435 11.25 6V8.25C11.25 9.04565 10.9339 9.80871 10.3713 10.3713C9.80871 10.9339 9.04565 11.25 8.25 11.25H6C5.20435 11.25 4.44129 10.9339 3.87868 10.3713C3.31607 9.80871 3 9.04565 3 8.25V6ZM12.75 6C12.75 5.20435 13.0661 4.44129 13.6287 3.87868C14.1913 3.31607 14.9544 3 15.75 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V8.25C21 9.04565 20.6839 9.80871 20.1213 10.3713C19.5587 10.9339 18.7956 11.25 18 11.25H15.75C14.9544 11.25 14.1913 10.9339 13.6287 10.3713C13.0661 9.80871 12.75 9.04565 12.75 8.25V6ZM3 15.75C3 14.9544 3.31607 14.1913 3.87868 13.6287C4.44129 13.0661 5.20435 12.75 6 12.75H8.25C9.04565 12.75 9.80871 13.0661 10.3713 13.6287C10.9339 14.1913 11.25 14.9544 11.25 15.75V18C11.25 18.7956 10.9339 19.5587 10.3713 20.1213C9.80871 20.6839 9.04565 21 8.25 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V15.75ZM12.75 15.75C12.75 14.9544 13.0661 14.1913 13.6287 13.6287C14.1913 13.0661 14.9544 12.75 15.75 12.75H18C18.7956 12.75 19.5587 13.0661 20.1213 13.6287C20.6839 14.1913 21 14.9544 21 15.75V18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21H15.75C14.9544 21 14.1913 20.6839 13.6287 20.1213C13.0661 19.5587 12.75 18.7956 12.75 18V15.75Z" fill="#BDBDBD"/>
    </svg>`,
        component: Products,
        layout: '/admin',
        show: true,
    },
    {
        path: '/products-create',
        name: 'Create Product',
        icon: 'ni ni-key-25 text-info',
        component: ProductsCreate,
        layout: '/admin',
        show: false,
    },
    {
        path: '/products-edit/:id',
        name: 'Edit Product',
        icon: 'ni ni-key-25 text-info',
        component: ProductsEdit,
        layout: '/admin',
        show: false,
    },
    {
        path: '/margin',
        name: 'Margin Setting',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M6 12C5.80109 12 5.61032 11.921 5.46967 11.7803C5.32902 11.6397 5.25 11.4489 5.25 11.25V3.75C5.25 3.55109 5.32902 3.36032 5.46967 3.21967C5.61032 3.07902 5.80109 3 6 3C6.19891 3 6.38968 3.07902 6.53033 3.21967C6.67098 3.36032 6.75 3.55109 6.75 3.75V11.25C6.75 11.4489 6.67098 11.6397 6.53033 11.7803C6.38968 11.921 6.19891 12 6 12ZM18 12C17.8011 12 17.6103 11.921 17.4697 11.7803C17.329 11.6397 17.25 11.4489 17.25 11.25V3.75C17.25 3.55109 17.329 3.36032 17.4697 3.21967C17.6103 3.07902 17.8011 3 18 3C18.1989 3 18.3897 3.07902 18.5303 3.21967C18.671 3.36032 18.75 3.55109 18.75 3.75V11.25C18.75 11.4489 18.671 11.6397 18.5303 11.7803C18.3897 11.921 18.1989 12 18 12ZM6.75 20.25V18.75C6.75 18.5511 6.67098 18.3603 6.53033 18.2197C6.38968 18.079 6.19891 18 6 18C5.80109 18 5.61032 18.079 5.46967 18.2197C5.32902 18.3603 5.25 18.5511 5.25 18.75V20.25C5.25 20.4489 5.32902 20.6397 5.46967 20.7803C5.61032 20.921 5.80109 21 6 21C6.19891 21 6.38968 20.921 6.53033 20.7803C6.67098 20.6397 6.75 20.4489 6.75 20.25ZM18.75 18.75V20.25C18.75 20.4489 18.671 20.6397 18.5303 20.7803C18.3897 20.921 18.1989 21 18 21C17.8011 21 17.6103 20.921 17.4697 20.7803C17.329 20.6397 17.25 20.4489 17.25 20.25V18.75C17.25 18.5511 17.329 18.3603 17.4697 18.2197C17.6103 18.079 17.8011 18 18 18C18.1989 18 18.3897 18.079 18.5303 18.2197C18.671 18.3603 18.75 18.5511 18.75 18.75ZM12.75 5.25V3.75C12.75 3.55109 12.671 3.36032 12.5303 3.21967C12.3897 3.07902 12.1989 3 12 3C11.8011 3 11.6103 3.07902 11.4697 3.21967C11.329 3.36032 11.25 3.55109 11.25 3.75V5.25C11.25 5.44891 11.329 5.63968 11.4697 5.78033C11.6103 5.92098 11.8011 6 12 6C12.1989 6 12.3897 5.92098 12.5303 5.78033C12.671 5.63968 12.75 5.44891 12.75 5.25ZM12 21C11.8011 21 11.6103 20.921 11.4697 20.7803C11.329 20.6397 11.25 20.4489 11.25 20.25V12.75C11.25 12.5511 11.329 12.3603 11.4697 12.2197C11.6103 12.079 11.8011 12 12 12C12.1989 12 12.3897 12.079 12.5303 12.2197C12.671 12.3603 12.75 12.5511 12.75 12.75V20.25C12.75 20.4489 12.671 20.6397 12.5303 20.7803C12.3897 20.921 12.1989 21 12 21ZM3.75 15C3.75 15.5967 3.98705 16.169 4.40901 16.591C4.83097 17.0129 5.40326 17.25 6 17.25C6.59674 17.25 7.16903 17.0129 7.59099 16.591C8.01295 16.169 8.25 15.5967 8.25 15C8.25 14.4033 8.01295 13.831 7.59099 13.409C7.16903 12.9871 6.59674 12.75 6 12.75C5.40326 12.75 4.83097 12.9871 4.40901 13.409C3.98705 13.831 3.75 14.4033 3.75 15ZM12 11.25C11.4033 11.25 10.831 11.0129 10.409 10.591C9.98705 10.169 9.75 9.59674 9.75 9C9.75 8.40326 9.98705 7.83097 10.409 7.40901C10.831 6.98705 11.4033 6.75 12 6.75C12.5967 6.75 13.169 6.98705 13.591 7.40901C14.0129 7.83097 14.25 8.40326 14.25 9C14.25 9.59674 14.0129 10.169 13.591 10.591C13.169 11.0129 12.5967 11.25 12 11.25ZM15.75 15C15.75 15.5967 15.9871 16.169 16.409 16.591C16.831 17.0129 17.4033 17.25 18 17.25C18.5967 17.25 19.169 17.0129 19.591 16.591C20.0129 16.169 20.25 15.5967 20.25 15C20.25 14.4033 20.0129 13.831 19.591 13.409C19.169 12.9871 18.5967 12.75 18 12.75C17.4033 12.75 16.831 12.9871 16.409 13.409C15.9871 13.831 15.75 14.4033 15.75 15Z" fill="#BDBDBD"/>
    </svg>`,
        component: Margins,
        layout: '/admin',
        show: true,
    },
    {
        path: '/margins-create',
        name: 'Create Margin',
        icon: 'ni ni-key-25 text-info',
        component: MarginsCreate,
        layout: '/admin',
        show: false,
    },
    {
        path: '/margins-edit/:id',
        name: 'Edit Margin',
        icon: 'ni ni-key-25 text-info',
        component: MarginsEdit,
        layout: '/admin',
        show: false,
    },
    {
        path: '/dynamic-price',
        name: 'Dynamic Price',
        icon: `<svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.67188 14.3298C8.67188 15.6198 9.66188 16.6598 10.8919 16.6598H13.4019C14.4719 16.6598 15.3419 15.7498 15.3419 14.6298C15.3419 13.4098 14.8119 12.9798 14.0219 12.6998L9.99187 11.2998C9.20187 11.0198 8.67188 10.5898 8.67188 9.36984C8.67188 8.24984 9.54187 7.33984 10.6119 7.33984H13.1219C14.3519 7.33984 15.3419 8.37984 15.3419 9.66984" stroke="#bdbdbd" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 6V18" stroke="#bdbdbd" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#bdbdbd" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        component: DynamicPrice,
        layout: '/admin',
        show: true,
    },
    {
        path: '/dynamic-price-create',
        name: 'Create Dynamic Price',
        icon: 'ni ni-key-25 text-info',
        component: DynamicPriceCreate,
        layout: '/admin',
        show: false,
    },
    {
        path: '/dynamic-price-edit/:id',
        name: 'Edit Dynamic Price',
        icon: 'ni ni-key-25 text-info',
        component: DynamicPriceEdit,
        layout: '/admin',
        show: false,
    },
    {
        path: '/template-setting',
        name: 'Template Link',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.9022 4.09817C19.5539 3.74984 19.1405 3.47353 18.6855 3.28502C18.2304 3.0965 17.7427 2.99947 17.2502 2.99947C16.7576 2.99947 16.2699 3.0965 15.8149 3.28502C15.3598 3.47353 14.9464 3.74984 14.5982 4.09817L10.0982 8.59817C9.67363 9.02234 9.35709 9.5422 9.17515 10.1141C8.99321 10.686 8.95117 11.2932 9.05258 11.8847C9.15399 12.4761 9.39587 13.0347 9.75792 13.5133C10.12 13.9919 10.5916 14.3766 11.1332 14.6352C11.3065 14.7245 11.4382 14.8778 11.5004 15.0625C11.5626 15.2473 11.5504 15.4491 11.4664 15.625C11.3824 15.8009 11.2332 15.9373 11.0504 16.0051C10.8676 16.0729 10.6656 16.0668 10.4872 15.9882C9.72928 15.6261 9.06931 15.0876 8.56268 14.4176C8.05605 13.7477 7.71755 12.966 7.57559 12.1382C7.43364 11.3104 7.49237 10.4606 7.74687 9.66013C8.00137 8.8597 8.44419 8.13201 9.03817 7.53817L13.5382 3.03817C14.0233 2.5403 14.6025 2.14374 15.2421 1.8715C15.8818 1.59926 16.5691 1.45675 17.2642 1.45226C17.9594 1.44776 18.6485 1.58136 19.2916 1.84531C19.9347 2.10925 20.519 2.49829 21.0105 2.98984C21.5021 3.48139 21.8911 4.06566 22.155 4.70876C22.419 5.35185 22.5526 6.04097 22.5481 6.7361C22.5436 7.43124 22.4011 8.11857 22.1288 8.7582C21.8566 9.39783 21.46 9.97702 20.9622 10.4622L19.2052 12.2192C19.1365 12.2929 19.0537 12.352 18.9617 12.393C18.8697 12.4339 18.7704 12.456 18.6697 12.4578C18.569 12.4595 18.469 12.441 18.3756 12.4033C18.2822 12.3656 18.1973 12.3094 18.1261 12.2382C18.0549 12.167 17.9988 12.0822 17.961 11.9888C17.9233 11.8954 17.9048 11.7954 17.9066 11.6946C17.9084 11.5939 17.9304 11.4946 17.9714 11.4026C18.0124 11.3106 18.0715 11.2278 18.1452 11.1592L19.9022 9.40217C20.2505 9.05394 20.5268 8.6405 20.7153 8.18546C20.9038 7.73043 21.0009 7.24271 21.0009 6.75017C21.0009 6.25763 20.9038 5.76991 20.7153 5.31488C20.5268 4.85984 20.2505 4.4464 19.9022 4.09817ZM12.5132 8.36517C12.599 8.18577 12.7526 8.04781 12.9401 7.98161C13.1276 7.91542 13.3337 7.92641 13.5132 8.01217C14.2711 8.3742 14.931 8.91278 15.4377 9.58269C15.9443 10.2526 16.2828 11.0343 16.4247 11.8621C16.5667 12.69 16.508 13.5398 16.2535 14.3402C15.999 15.1406 15.5561 15.8683 14.9622 16.4622L10.4622 20.9622C9.97702 21.46 9.39783 21.8566 8.7582 22.1288C8.11857 22.4011 7.43124 22.5436 6.7361 22.5481C6.04097 22.5526 5.35185 22.419 4.70876 22.155C4.06566 21.8911 3.48139 21.5021 2.98984 21.0105C2.49829 20.519 2.10925 19.9347 1.84531 19.2916C1.58136 18.6485 1.44776 17.9594 1.45226 17.2642C1.45675 16.5691 1.59926 15.8818 1.8715 15.2421C2.14374 14.6025 2.5403 14.0233 3.03817 13.5382L4.79517 11.7812C4.86383 11.7075 4.94663 11.6484 5.03863 11.6074C5.13063 11.5664 5.22994 11.5444 5.33065 11.5426C5.43135 11.5408 5.53138 11.5593 5.62477 11.597C5.71815 11.6348 5.80299 11.6909 5.87421 11.7621C5.94543 11.8334 6.00157 11.9182 6.03929 12.0116C6.07701 12.105 6.09554 12.205 6.09376 12.3057C6.09198 12.4064 6.06994 12.5057 6.02895 12.5977C5.98796 12.6897 5.92886 12.7725 5.85517 12.8412L4.09817 14.5982C3.7499 14.9464 3.47364 15.3599 3.28516 15.8149C3.09668 16.2699 2.99967 16.7576 2.99967 17.2502C2.99967 17.7427 3.09668 18.2304 3.28516 18.6854C3.47364 19.1405 3.7499 19.5539 4.09817 19.9022C4.44643 20.2504 4.85989 20.5267 5.31492 20.7152C5.76995 20.9037 6.25765 21.0007 6.75017 21.0007C7.24269 21.0007 7.73039 20.9037 8.18542 20.7152C8.64045 20.5267 9.0539 20.2504 9.40217 19.9022L13.9022 15.4022C14.3267 14.978 14.6432 14.4581 14.8252 13.8863C15.0071 13.3144 15.0492 12.7072 14.9478 12.1157C14.8464 11.5242 14.6045 10.9657 14.2424 10.4871C13.8804 10.0084 13.4088 9.6237 12.8672 9.36517C12.7783 9.32276 12.6986 9.26326 12.6327 9.19005C12.5667 9.11684 12.5159 9.03136 12.483 8.9385C12.4501 8.84564 12.4359 8.74721 12.4411 8.64884C12.4462 8.55046 12.4707 8.45407 12.5132 8.36517Z" fill="#bdbdbd"/>
        </svg>`,
        component: TemplateSetting,
        layout: '/admin',
        show: true,
    },
    {
        path: '/csv',
        name: 'Download CSV',
        icon: 'fa fa-file-excel',
        component: CSV,
        layout: '/admin',
        show: true,
    },
    {
        path: '/plugin',
        name: 'Download Plugin',
        icon: 'fa fa-download',
        component: Plugin,
        layout: '/admin',
        show: true,
    },
    {
        path: '/user-profile',
        name: 'Password',
        icon: 'ni ni-single-02 text-primary',
        component: Profile,
        layout: '/admin',
        show: false,
    },
    {
        path: '/livechat',
        name: 'Live Chat Support',
        icon: 'ni ni-single-02 text-primary',
        component: LiveChat,
        layout: '/admin',
        show: false,
    },
    {
        path: '/auth/login',
        name: 'Logout',
        icon: 'ni ni-user-run text-danger',
        layout: '/admin',
        show: true,
    },
];
export default routes;
